import {
	SET_FIELD_TYPES,
	SET_FIELD_TYPE,
	CLEAR_FIELD_TYPES,
	CLEAR_FIELD_TYPE,
	ADD_FIELD_TYPE,
	UPDATE_FIELD_TYPE,
	REMOVE_FIELD_TYPE,
} from './actionTypes';

export const fieldType = (state = {}, action) => {
	switch (action.type) {
		case SET_FIELD_TYPE:
			return action.payload;
		case UPDATE_FIELD_TYPE:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_FIELD_TYPE:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_FIELD_TYPES:
			return action.payload;
		case ADD_FIELD_TYPE:
			return [...state, action.payload];
		case UPDATE_FIELD_TYPE:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_FIELD_TYPE:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_FIELD_TYPES:
			return [];
		default:
			return state;
	}
};
